var config = {
    debug: {
    },
    planData: {
        // "1": {
        //     name: 'Free',
        //     userPrice: {
        //         "A": 0,
        //         "M": 0
        //     }
        // },
        "2": {
            name: 'Solo',
            userPrice: {
                "A": 799,
                "M": 74
            },
            requiresCreditCard: true
            // discountFactor: {
            //     "A": 0.75
            // }
        },
        "3": {
            name: 'Professional',
            userPrice: {
                "A": 583,      // non-discounted:  44              // discounted:  30.8
                "M": 54       // non-discounted:  49              // discounted:  34.3
            },
            minUsers: 2,
            maxUsers: 10,
            requiresCreditCard: true
            // discountFactor: {
            //     "A": 0.75
            // }
        }
    },
    coupons: {
        // "22BF": {
        //     plans: [3],
        //     discountFactor: {
        //         "A": 0.6
        //     }
        // }
        // "BF2225": {
        //     plans: [3],
        //     discountFactor: {
        //         "A": 0.75
        //     }
        // },
        // "TLDMC": {
        //     plans: [3],
        //     discountFactor: {
        //         "A": 0.7
        //     }
        // }
    },
    messages: {
        catchAllError: ("An unexpected problem has occurred with your submission.  Please contact " +
            "<a href=\"mailto:support@designdocs.com\">support@designdocs.com</a>, and reference the" +
            " email address you used in the signup form."),
        alreadyEnteredNotValidated: ("This email address already appears to be in our system.<br>" +
            " Perhaps you previously started to sign up, but never completed " +
            " the email validation.  Would you like to <b>re-send</b> a validation code " +
            " to this email address now ? "),
        alreadyValidatedNotSigned: ("Your email has already been validated with our system in a past session, " +
            " however you never finished the signup process.<br><br>Please complete the fields and " +
            " click the [Next] button"),
        emailDuplicate: ("This email address already corresponds to an active account in DesignDocs.  Please contact " +
            "<a href=\"mailto:support@designdocs.com\">support@designdocs.com</a>, or use a different email."),
        success: ("Thank you for signing up ! <br> " +
            "You should receive a welcome email with information about your account in the next couple of minutes.  " +
            "If you don't, please contact " +
            "<a href=\"mailto:support@designdocs.com\">support@designdocs.com</a>, and reference the" +
            " email address you used in the signup form "),
        emailResetQuestion: ("If you reset the email field, you will need to repeat the email validation process " +
            "for a different email address."
        )
    }
};

function isCouponValid(code, plan, freq) {
    const coupon = config.coupons[code];
    return (coupon && coupon.plans.includes(plan) && Object.keys(coupon.discountFactor).includes(freq));
}
function doesCouponCodeExist(code) {
    return (!!config.coupons[code]);
}

var countries = [
    { "key": 840, "label": "United States" },
    { "key": 124, "label": "Canada" },
    { "key": 826, "label": "United Kingdom" },
    { "key": 36, "label": "Australia" },
    { "key": 276, "label": "Germany" },
    { "key": 554, "label": "New Zealand" },
    { "key": 528, "label": "Netherlands" },
    { "key": 250, "label": "France" },
    { "key": 752, "label": "Sweden" },
    { "key": 156, "label": "China" },
    { "key": 4, "label": "Afghanistan" },
    { "key": 8, "label": "Albania" },
    { "key": 10, "label": "Antarctica" },
    { "key": 12, "label": "Algeria" },
    { "key": 16, "label": "American Samoa" },
    { "key": 20, "label": "Andorra" },
    { "key": 24, "label": "Angola" },
    { "key": 28, "label": "Antigua and Barbuda" },
    { "key": 31, "label": "Azerbaijan" },
    { "key": 32, "label": "Argentina" },
    { "key": 40, "label": "Austria" },
    { "key": 44, "label": "Bahamas" },
    { "key": 48, "label": "Bahrain" },
    { "key": 50, "label": "Bangladesh" },
    { "key": 51, "label": "Armenia" },
    { "key": 52, "label": "Barbados" },
    { "key": 56, "label": "Belgium" },
    { "key": 60, "label": "Bermuda" },
    { "key": 64, "label": "Bhutan" },
    { "key": 68, "label": "Bolivia, Plurinational State Of" },
    { "key": 70, "label": "Bosnia and Herzegovina" },
    { "key": 72, "label": "Botswana" },
    { "key": 74, "label": "Bouvet Island" },
    { "key": 76, "label": "Brazil" },
    { "key": 84, "label": "Belize" },
    { "key": 86, "label": "British Indian Ocean Territory" },
    { "key": 90, "label": "Solomon Islands" },
    { "key": 92, "label": "Virgin Islands, British" },
    { "key": 96, "label": "Brunei Darussalam" },
    { "key": 100, "label": "Bulgaria" },
    { "key": 104, "label": "Myanmar" },
    { "key": 108, "label": "Burundi" },
    { "key": 112, "label": "Belarus" },
    { "key": 116, "label": "Cambodia" },
    { "key": 120, "label": "Cameroon" },
    { "key": 132, "label": "Cape Verde" },
    { "key": 136, "label": "Cayman Islands" },
    { "key": 140, "label": "Central African Republic" },
    { "key": 144, "label": "Sri Lanka" },
    { "key": 148, "label": "Chad" },
    { "key": 152, "label": "Chile" },
    { "key": 158, "label": "Taiwan, Province of China" },
    { "key": 162, "label": "Christmas Island" },
    { "key": 166, "label": "Cocos (Keeling) Islands" },
    { "key": 170, "label": "Colombia" },
    { "key": 174, "label": "Comoros" },
    { "key": 175, "label": "Mayotte" },
    { "key": 178, "label": "Congo" },
    { "key": 180, "label": "Congo, the Democratic Republic of the" },
    { "key": 184, "label": "Cook Islands" },
    { "key": 188, "label": "Costa Rica" },
    { "key": 191, "label": "Croatia" },
    { "key": 192, "label": "Cuba" },
    { "key": 196, "label": "Cyprus" },
    { "key": 203, "label": "Czech Republic" },
    { "key": 204, "label": "Benin" },
    { "key": 208, "label": "Denmark" },
    { "key": 212, "label": "Dominica" },
    { "key": 214, "label": "Dominican Republic" },
    { "key": 218, "label": "Ecuador" },
    { "key": 222, "label": "El Salvador" },
    { "key": 226, "label": "Equatorial Guinea" },
    { "key": 231, "label": "Ethiopia" },
    { "key": 232, "label": "Eritrea" },
    { "key": 233, "label": "Estonia" },
    { "key": 234, "label": "Faroe Islands" },
    { "key": 238, "label": "Falkland Islands  (Malvinas)" },
    { "key": 239, "label": "South Georgia and the South Sandwich Islands" },
    { "key": 242, "label": "Fiji" },
    { "key": 246, "label": "Finland" },
    { "key": 248, "label": "Åland Islands" },
    { "key": 254, "label": "French Guiana" },
    { "key": 258, "label": "French Polynesia" },
    { "key": 260, "label": "French Southern Territories" },
    { "key": 262, "label": "Djibouti" },
    { "key": 266, "label": "Gabon" },
    { "key": 268, "label": "Georgia" },
    { "key": 270, "label": "Gambia" },
    { "key": 275, "label": "Palestinian Territory, Occupied" },
    { "key": 288, "label": "Ghana" },
    { "key": 292, "label": "Gibraltar" },
    { "key": 296, "label": "Kiribati" },
    { "key": 300, "label": "Greece" },
    { "key": 304, "label": "Greenland" },
    { "key": 308, "label": "Grenada" },
    { "key": 312, "label": "Guadeloupe" },
    { "key": 316, "label": "Guam" },
    { "key": 320, "label": "Guatemala" },
    { "key": 324, "label": "Guinea" },
    { "key": 328, "label": "Guyana" },
    { "key": 332, "label": "Haiti" },
    { "key": 334, "label": "Heard Island and Mcdonald Islands" },
    { "key": 336, "label": "Holy See (Vatican City State)" },
    { "key": 340, "label": "Honduras" },
    { "key": 344, "label": "Hong Kong" },
    { "key": 348, "label": "Hungary" },
    { "key": 352, "label": "Iceland" },
    { "key": 356, "label": "India" },
    { "key": 360, "label": "Indonesia" },
    { "key": 364, "label": "Iran, Islamic Republic of" },
    { "key": 368, "label": "Iraq" },
    { "key": 372, "label": "Ireland" },
    { "key": 376, "label": "Israel" },
    { "key": 380, "label": "Italy" },
    { "key": 384, "label": "Côte d'Ivoire" },
    { "key": 388, "label": "Jamaica" },
    { "key": 392, "label": "Japan" },
    { "key": 398, "label": "Kazakhstan" },
    { "key": 400, "label": "Jordan" },
    { "key": 404, "label": "Kenya" },
    { "key": 408, "label": "Korea, Democratic People's Republic of" },
    { "key": 410, "label": "Korea, Republic of" },
    { "key": 414, "label": "Kuwait" },
    { "key": 417, "label": "Kyrgyzstan" },
    { "key": 418, "label": "Lao People's Democratic Republic" },
    { "key": 422, "label": "Lebanon" },
    { "key": 426, "label": "Lesotho" },
    { "key": 428, "label": "Latvia" },
    { "key": 430, "label": "Liberia" },
    { "key": 434, "label": "Libya" },
    { "key": 438, "label": "Liechtenstein" },
    { "key": 440, "label": "Lithuania" },
    { "key": 442, "label": "Luxembourg" },
    { "key": 446, "label": "Macao" },
    { "key": 450, "label": "Madagascar" },
    { "key": 454, "label": "Malawi" },
    { "key": 458, "label": "Malaysia" },
    { "key": 462, "label": "Maldives" },
    { "key": 466, "label": "Mali" },
    { "key": 470, "label": "Malta" },
    { "key": 474, "label": "Martinique" },
    { "key": 478, "label": "Mauritania" },
    { "key": 480, "label": "Mauritius" },
    { "key": 484, "label": "Mexico" },
    { "key": 492, "label": "Monaco" },
    { "key": 496, "label": "Mongolia" },
    { "key": 498, "label": "Moldova, Republic of" },
    { "key": 499, "label": "Montenegro" },
    { "key": 500, "label": "Montserrat" },
    { "key": 504, "label": "Morocco" },
    { "key": 508, "label": "Mozambique" },
    { "key": 512, "label": "Oman" },
    { "key": 516, "label": "Namibia" },
    { "key": 520, "label": "Nauru" },
    { "key": 524, "label": "Nepal" },
    { "key": 531, "label": "Curaçao" },
    { "key": 533, "label": "Aruba" },
    { "key": 534, "label": "Sint Maarten (Dutch part)" },
    { "key": 535, "label": "Bonaire, Sint Eustatius and Saba" },
    { "key": 540, "label": "New Caledonia" },
    { "key": 548, "label": "Vanuatu" },
    { "key": 558, "label": "Nicaragua" },
    { "key": 562, "label": "Niger" },
    { "key": 566, "label": "Nigeria" },
    { "key": 570, "label": "Niue" },
    { "key": 574, "label": "Norfolk Island" },
    { "key": 578, "label": "Norway" },
    { "key": 580, "label": "Northern Mariana Islands" },
    { "key": 581, "label": "United States Minor Outlying Islands" },
    { "key": 583, "label": "Micronesia, Federated States of" },
    { "key": 584, "label": "Marshall Islands" },
    { "key": 585, "label": "Palau" },
    { "key": 586, "label": "Pakistan" },
    { "key": 591, "label": "Panama" },
    { "key": 598, "label": "Papua New Guinea" },
    { "key": 600, "label": "Paraguay" },
    { "key": 604, "label": "Peru" },
    { "key": 608, "label": "Philippines" },
    { "key": 612, "label": "Pitcairn" },
    { "key": 616, "label": "Poland" },
    { "key": 620, "label": "Portugal" },
    { "key": 624, "label": "Guinea-Bissau" },
    { "key": 626, "label": "Timor-Leste" },
    { "key": 630, "label": "Puerto Rico" },
    { "key": 634, "label": "Qatar" },
    { "key": 638, "label": "Réunion" },
    { "key": 642, "label": "Romania" },
    { "key": 643, "label": "Russian Federation" },
    { "key": 646, "label": "Rwanda" },
    { "key": 652, "label": "Saint Barthélemy" },
    { "key": 654, "label": "Saint Helena, Ascension and Tristan da Cunha" },
    { "key": 659, "label": "Saint Kitts and Nevis" },
    { "key": 660, "label": "Anguilla" },
    { "key": 662, "label": "Saint Lucia" },
    { "key": 663, "label": "Saint Martin (French part)" },
    { "key": 666, "label": "Saint Pierre and Miquelon" },
    { "key": 670, "label": "Saint Vincent and the Grenadines" },
    { "key": 674, "label": "San Marino" },
    { "key": 678, "label": "Sao Tome and Principe" },
    { "key": 682, "label": "Saudi Arabia" },
    { "key": 686, "label": "Senegal" },
    { "key": 688, "label": "Serbia" },
    { "key": 690, "label": "Seychelles" },
    { "key": 694, "label": "Sierra Leone" },
    { "key": 702, "label": "Singapore" },
    { "key": 703, "label": "Slovakia" },
    { "key": 704, "label": "Viet Nam" },
    { "key": 705, "label": "Slovenia" },
    { "key": 706, "label": "Somalia" },
    { "key": 710, "label": "South Africa" },
    { "key": 716, "label": "Zimbabwe" },
    { "key": 724, "label": "Spain" },
    { "key": 728, "label": "South Sudan" },
    { "key": 729, "label": "Sudan" },
    { "key": 732, "label": "Western Sahara" },
    { "key": 740, "label": "Suriname" },
    { "key": 744, "label": "Svalbard and Jan Mayen" },
    { "key": 748, "label": "Swaziland" },
    { "key": 756, "label": "Switzerland" },
    { "key": 760, "label": "Syrian Arab Republic" },
    { "key": 762, "label": "Tajikistan" },
    { "key": 764, "label": "Thailand" },
    { "key": 768, "label": "Togo" },
    { "key": 772, "label": "Tokelau" },
    { "key": 776, "label": "Tonga" },
    { "key": 780, "label": "Trinidad and Tobago" },
    { "key": 784, "label": "United Arab Emirates" },
    { "key": 788, "label": "Tunisia" },
    { "key": 792, "label": "Turkey" },
    { "key": 795, "label": "Turkmenistan" },
    { "key": 796, "label": "Turks and Caicos Islands" },
    { "key": 798, "label": "Tuvalu" },
    { "key": 800, "label": "Uganda" },
    { "key": 804, "label": "Ukraine" },
    { "key": 807, "label": "Macedonia, the Former Yugoslav Republic of" },
    { "key": 818, "label": "Egypt" },
    { "key": 831, "label": "Guernsey" },
    { "key": 832, "label": "Jersey" },
    { "key": 833, "label": "Isle of Man" },
    { "key": 834, "label": "Tanzania, United Republic of" },
    { "key": 850, "label": "Virgin Islands, U.s." },
    { "key": 854, "label": "Burkina Faso" },
    { "key": 858, "label": "Uruguay" },
    { "key": 860, "label": "Uzbekistan" },
    { "key": 862, "label": "Venezuela, Bolivarian Republic of" },
    { "key": 876, "label": "Wallis and Futuna" },
    { "key": 882, "label": "Samoa" },
    { "key": 887, "label": "Yemen" },
    { "key": 894, "label": "Zambia" }];

var territories = [
    { "country-id": 124, "key": 1, "label": "Alberta" },
    { "country-id": 124, "key": 2, "label": "British Columbia" },
    { "country-id": 124, "key": 3, "label": "Manitoba" },
    { "country-id": 124, "key": 4, "label": "New Brunswick" },
    { "country-id": 124, "key": 5, "label": "Newfoundland and Labrador" },
    { "country-id": 124, "key": 6, "label": "Northwest Territories" },
    { "country-id": 124, "key": 7, "label": "Nova Scotia" },
    { "country-id": 124, "key": 8, "label": "Nunavut" },
    { "country-id": 124, "key": 9, "label": "Ontario" },
    { "country-id": 124, "key": 10, "label": "Prince Edward Island" },
    { "country-id": 124, "key": 11, "label": "Quebec" },
    { "country-id": 124, "key": 12, "label": "Saskatchewan" },
    { "country-id": 124, "key": 13, "label": "Yukon Territory" },
    { "country-id": 840, "key": 14, "label": "Alaska" },
    { "country-id": 840, "key": 15, "label": "Alabama" },
    { "country-id": 840, "key": 16, "label": "Arizona" },
    { "country-id": 840, "key": 17, "label": "Arkansas" },
    { "country-id": 840, "key": 18, "label": "California" },
    { "country-id": 840, "key": 19, "label": "Colorado" },
    { "country-id": 840, "key": 20, "label": "Connecticut" },
    { "country-id": 840, "key": 21, "label": "Delaware" },
    { "country-id": 840, "key": 22, "label": "District of Columbia" },
    { "country-id": 840, "key": 23, "label": "Florida" },
    { "country-id": 840, "key": 24, "label": "Georgia" },
    { "country-id": 840, "key": 25, "label": "Hawaii" },
    { "country-id": 840, "key": 26, "label": "Idaho" },
    { "country-id": 840, "key": 27, "label": "Illinois" },
    { "country-id": 840, "key": 28, "label": "Indiana" },
    { "country-id": 840, "key": 29, "label": "Iowa" },
    { "country-id": 840, "key": 30, "label": "Kansas" },
    { "country-id": 840, "key": 31, "label": "Kentucky" },
    { "country-id": 840, "key": 32, "label": "Louisiana" },
    { "country-id": 840, "key": 33, "label": "Maine" },
    { "country-id": 840, "key": 34, "label": "Maryland" },
    { "country-id": 840, "key": 35, "label": "Massachusetts" },
    { "country-id": 840, "key": 36, "label": "Michigan" },
    { "country-id": 840, "key": 37, "label": "Minnesota" },
    { "country-id": 840, "key": 38, "label": "Mississippi" },
    { "country-id": 840, "key": 39, "label": "Missouri" },
    { "country-id": 840, "key": 40, "label": "Montana" },
    { "country-id": 840, "key": 41, "label": "Nebraska" },
    { "country-id": 840, "key": 42, "label": "Nevada" },
    { "country-id": 840, "key": 43, "label": "New Hampshire" },
    { "country-id": 840, "key": 44, "label": "New Jersey" },
    { "country-id": 840, "key": 45, "label": "New Mexico" },
    { "country-id": 840, "key": 46, "label": "New York" },
    { "country-id": 840, "key": 47, "label": "North Carolina" },
    { "country-id": 840, "key": 48, "label": "North Dakota" },
    { "country-id": 840, "key": 49, "label": "Ohio" },
    { "country-id": 840, "key": 50, "label": "Oklahoma" },
    { "country-id": 840, "key": 51, "label": "Oregon" },
    { "country-id": 840, "key": 52, "label": "Pennsylvania" },
    { "country-id": 840, "key": 53, "label": "Puerto Rico" },
    { "country-id": 840, "key": 54, "label": "Rhode Island" },
    { "country-id": 840, "key": 55, "label": "South Carolina" },
    { "country-id": 840, "key": 56, "label": "South Dakota" },
    { "country-id": 840, "key": 57, "label": "Tennessee" },
    { "country-id": 840, "key": 58, "label": "Texas" },
    { "country-id": 840, "key": 59, "label": "Utah" },
    { "country-id": 840, "key": 60, "label": "Vermont" },
    { "country-id": 840, "key": 61, "label": "Virginia" },
    { "country-id": 840, "key": 62, "label": "Washington" },
    { "country-id": 840, "key": 63, "label": "West Virginia" },
    { "country-id": 840, "key": 64, "label": "Wisconsin" },
    { "country-id": 840, "key": 65, "label": "Wyoming" },
    { "country-id": 36, "key": 4118, "label": "Australian Capital Territory" },
    { "country-id": 36, "key": 4119, "label": "New South Wales" },
    { "country-id": 36, "key": 4120, "label": "Northern Territory" },
    { "country-id": 36, "key": 4121, "label": "Queensland" },
    { "country-id": 36, "key": 4122, "label": "South Australia" },
    { "country-id": 36, "key": 4123, "label": "Tasmania" },
    { "country-id": 36, "key": 4124, "label": "Victoria" },
    { "country-id": 36, "key": 4125, "label": "Western Australia" },
    { "country-id": 826, "key": 4155, "label": "Cheshire West and Chester" },
    { "country-id": 826, "key": 4173, "label": "Central Bedfordshire" },
    { "country-id": 156, "key": 4577, "label": "Anhui" },
    { "country-id": 156, "key": 4578, "label": "Zhejiang" },
    { "country-id": 156, "key": 4579, "label": "Jiangxi" },
    { "country-id": 156, "key": 4580, "label": "Jiangsu" },
    { "country-id": 156, "key": 4581, "label": "Jilin" },
    { "country-id": 156, "key": 4582, "label": "Qinghai" },
    { "country-id": 156, "key": 4583, "label": "Fujian" },
    { "country-id": 156, "key": 4584, "label": "Heilongjiang" },
    { "country-id": 156, "key": 4585, "label": "Henan" },
    { "country-id": 156, "key": 4586, "label": "Hebei" },
    { "country-id": 156, "key": 4587, "label": "Hunan" },
    { "country-id": 156, "key": 4588, "label": "Hubei" },
    { "country-id": 156, "key": 4589, "label": "Xinjiang" },
    { "country-id": 156, "key": 4590, "label": "Xizang" },
    { "country-id": 156, "key": 4591, "label": "Gansu" },
    { "country-id": 156, "key": 4592, "label": "Guangxi" },
    { "country-id": 156, "key": 4593, "label": "Guizhou" },
    { "country-id": 156, "key": 4594, "label": "Liaoning" },
    { "country-id": 156, "key": 4595, "label": "Nei Mongol" },
    { "country-id": 156, "key": 4596, "label": "Ningxia" },
    { "country-id": 156, "key": 4597, "label": "Beijing" },
    { "country-id": 156, "key": 4598, "label": "Shanghai" },
    { "country-id": 156, "key": 4599, "label": "Shanxi" },
    { "country-id": 156, "key": 4600, "label": "Shandong" },
    { "country-id": 156, "key": 4601, "label": "Shaanxi" },
    { "country-id": 156, "key": 4602, "label": "Tianjin" },
    { "country-id": 156, "key": 4603, "label": "Yunnan" },
    { "country-id": 156, "key": 4604, "label": "Guangdong" },
    { "country-id": 156, "key": 4605, "label": "Hainan" },
    { "country-id": 156, "key": 4606, "label": "Sichuan" },
    { "country-id": 156, "key": 4607, "label": "Chongqing" },
    { "country-id": 276, "key": 4703, "label": "Baden-Württemberg" },
    { "country-id": 276, "key": 4704, "label": "Bayern" },
    { "country-id": 276, "key": 4705, "label": "Bremen" },
    { "country-id": 276, "key": 4706, "label": "Hamburg" },
    { "country-id": 276, "key": 4707, "label": "Hessen" },
    { "country-id": 276, "key": 4708, "label": "Niedersachsen" },
    { "country-id": 276, "key": 4709, "label": "Nordrhein-Westfalen" },
    { "country-id": 276, "key": 4710, "label": "Rheinland-Pfalz" },
    { "country-id": 276, "key": 4711, "label": "Saarland" },
    { "country-id": 276, "key": 4712, "label": "Schleswig-Holstein" },
    { "country-id": 276, "key": 4713, "label": "Brandenburg" },
    { "country-id": 276, "key": 4714, "label": "Mecklenburg-Vorpommern" },
    { "country-id": 276, "key": 4715, "label": "Sachsen" },
    { "country-id": 276, "key": 4716, "label": "Sachsen-Anhalt" },
    { "country-id": 276, "key": 4717, "label": "Thuringen" },
    { "country-id": 276, "key": 4718, "label": "Berlin" },
    { "country-id": 250, "key": 4940, "label": "Aquitaine" },
    { "country-id": 250, "key": 4941, "label": "Auvergne" },
    { "country-id": 250, "key": 4942, "label": "Basse-Normandie" },
    { "country-id": 250, "key": 4943, "label": "Bourgogne" },
    { "country-id": 250, "key": 4944, "label": "Bretagne" },
    { "country-id": 250, "key": 4945, "label": "Centre" },
    { "country-id": 250, "key": 4946, "label": "Champagne-Ardenne" },
    { "country-id": 250, "key": 4947, "label": "Corse" },
    { "country-id": 250, "key": 4948, "label": "Franche-Comte" },
    { "country-id": 250, "key": 4949, "label": "Haute-Normandie" },
    { "country-id": 250, "key": 4950, "label": "ÃŽle-de-France" },
    { "country-id": 250, "key": 4951, "label": "Languedoc-Roussillon" },
    { "country-id": 250, "key": 4952, "label": "Limousin" },
    { "country-id": 250, "key": 4953, "label": "Lorraine" },
    { "country-id": 250, "key": 4954, "label": "Midi-Pyrenees" },
    { "country-id": 250, "key": 4955, "label": "Nord-Pas-de-Calais" },
    { "country-id": 250, "key": 4956, "label": "Pays-de-la-Loire" },
    { "country-id": 250, "key": 4957, "label": "Picardie" },
    { "country-id": 250, "key": 4958, "label": "Poitou-Charentes" },
    { "country-id": 250, "key": 4959, "label": "Provence-Alpes-Cote d'Azur" },
    { "country-id": 250, "key": 4960, "label": "RhÃ´ne-Alpes" },
    { "country-id": 250, "key": 4961, "label": "Alsace" },
    { "country-id": 826, "key": 4971, "label": "Barking and Dagenham" },
    { "country-id": 826, "key": 4972, "label": "Barnet" },
    { "country-id": 826, "key": 4973, "label": "Barnsley" },
    { "country-id": 826, "key": 4974, "label": "Bath and North East Somerset" },
    { "country-id": 826, "key": 4975, "label": "Bedfordshire" },
    { "country-id": 826, "key": 4976, "label": "Bexley" },
    { "country-id": 826, "key": 4977, "label": "Birmingham" },
    { "country-id": 826, "key": 4978, "label": "Blackburn with Darwen" },
    { "country-id": 826, "key": 4979, "label": "Blackpool" },
    { "country-id": 826, "key": 4980, "label": "Bolton" },
    { "country-id": 826, "key": 4981, "label": "Bournemouth" },
    { "country-id": 826, "key": 4982, "label": "Bracknell Forest" },
    { "country-id": 826, "key": 4983, "label": "Bradford" },
    { "country-id": 826, "key": 4984, "label": "Brent" },
    { "country-id": 826, "key": 4985, "label": "Brighton and Hove" },
    { "country-id": 826, "key": 4986, "label": "Bristol, City of" },
    { "country-id": 826, "key": 4987, "label": "Bromley" },
    { "country-id": 826, "key": 4988, "label": "Buckinghamshire" },
    { "country-id": 826, "key": 4989, "label": "Bury" },
    { "country-id": 826, "key": 4990, "label": "Calderdale" },
    { "country-id": 826, "key": 4991, "label": "Cambridgeshire" },
    { "country-id": 826, "key": 4992, "label": "Camden" },
    { "country-id": 826, "key": 4993, "label": "Cheshire East" },
    { "country-id": 826, "key": 4994, "label": "Cornwall" },
    { "country-id": 826, "key": 4995, "label": "Coventry" },
    { "country-id": 826, "key": 4996, "label": "Croydon" },
    { "country-id": 826, "key": 4997, "label": "Cumbria" },
    { "country-id": 826, "key": 4998, "label": "Darlington" },
    { "country-id": 826, "key": 4999, "label": "Derby" },
    { "country-id": 826, "key": 5000, "label": "Derbyshire" },
    { "country-id": 826, "key": 5001, "label": "Devon" },
    { "country-id": 826, "key": 5002, "label": "Doncaster" },
    { "country-id": 826, "key": 5003, "label": "Dorset" },
    { "country-id": 826, "key": 5004, "label": "Dudley" },
    { "country-id": 826, "key": 5005, "label": "Durham" },
    { "country-id": 826, "key": 5006, "label": "Ealing" },
    { "country-id": 826, "key": 5007, "label": "East Riding of Yorkshire" },
    { "country-id": 826, "key": 5008, "label": "East Sussex" },
    { "country-id": 826, "key": 5009, "label": "Enfield" },
    { "country-id": 826, "key": 5010, "label": "Essex" },
    { "country-id": 826, "key": 5011, "label": "Gateshead" },
    { "country-id": 826, "key": 5012, "label": "Gloucestershire" },
    { "country-id": 826, "key": 5013, "label": "Greenwich" },
    { "country-id": 826, "key": 5014, "label": "Hackney" },
    { "country-id": 826, "key": 5015, "label": "Halton" },
    { "country-id": 826, "key": 5016, "label": "Hammersmith and Fulham" },
    { "country-id": 826, "key": 5017, "label": "Hampshire" },
    { "country-id": 826, "key": 5018, "label": "Haringey" },
    { "country-id": 826, "key": 5019, "label": "Harrow" },
    { "country-id": 826, "key": 5020, "label": "Hartlepool" },
    { "country-id": 826, "key": 5021, "label": "Havering" },
    { "country-id": 826, "key": 5022, "label": "Herefordshire" },
    { "country-id": 826, "key": 5023, "label": "Hertford" },
    { "country-id": 826, "key": 5024, "label": "Hillingdon" },
    { "country-id": 826, "key": 5025, "label": "Hounslow" },
    { "country-id": 826, "key": 5026, "label": "Isle of Wight" },
    { "country-id": 826, "key": 5027, "label": "Islington" },
    { "country-id": 826, "key": 5028, "label": "Kensington and Chelsea" },
    { "country-id": 826, "key": 5029, "label": "Kent" },
    { "country-id": 826, "key": 5030, "label": "Kingston upon Hull, City of" },
    { "country-id": 826, "key": 5031, "label": "Kingston upon Thames" },
    { "country-id": 826, "key": 5032, "label": "Kirklees" },
    { "country-id": 826, "key": 5033, "label": "Knowsley" },
    { "country-id": 826, "key": 5034, "label": "Lambeth" },
    { "country-id": 826, "key": 5035, "label": "Lancashire" },
    { "country-id": 826, "key": 5036, "label": "Leeds" },
    { "country-id": 826, "key": 5037, "label": "Leicester" },
    { "country-id": 826, "key": 5038, "label": "Leicestershire" },
    { "country-id": 826, "key": 5039, "label": "Lewisham" },
    { "country-id": 826, "key": 5040, "label": "Lincolnshire" },
    { "country-id": 826, "key": 5041, "label": "Liverpool" },
    { "country-id": 826, "key": 5042, "label": "London, City of" },
    { "country-id": 826, "key": 5043, "label": "Luton" },
    { "country-id": 826, "key": 5044, "label": "Manchester" },
    { "country-id": 826, "key": 5045, "label": "Medway" },
    { "country-id": 826, "key": 5046, "label": "Merton" },
    { "country-id": 826, "key": 5047, "label": "Middlesbrough" },
    { "country-id": 826, "key": 5048, "label": "Milton Keynes" },
    { "country-id": 826, "key": 5049, "label": "Newcastle upon Tyne" },
    { "country-id": 826, "key": 5050, "label": "Newham" },
    { "country-id": 826, "key": 5051, "label": "Norfolk" },
    { "country-id": 826, "key": 5052, "label": "Northamptonshire" },
    { "country-id": 826, "key": 5053, "label": "North East Lincolnshire" },
    { "country-id": 826, "key": 5054, "label": "North Lincolnshire" },
    { "country-id": 826, "key": 5055, "label": "North Somerset" },
    { "country-id": 826, "key": 5056, "label": "North Tyneside" },
    { "country-id": 826, "key": 5057, "label": "Northumberland" },
    { "country-id": 826, "key": 5058, "label": "North Yorkshire" },
    { "country-id": 826, "key": 5059, "label": "Nottingham" },
    { "country-id": 826, "key": 5060, "label": "Nottinghamshire" },
    { "country-id": 826, "key": 5061, "label": "Oldham" },
    { "country-id": 826, "key": 5062, "label": "Oxfordshire" },
    { "country-id": 826, "key": 5063, "label": "Peterborough" },
    { "country-id": 826, "key": 5064, "label": "Plymouth" },
    { "country-id": 826, "key": 5065, "label": "Poole" },
    { "country-id": 826, "key": 5066, "label": "Portsmouth" },
    { "country-id": 826, "key": 5067, "label": "Reading" },
    { "country-id": 826, "key": 5068, "label": "Redbridge" },
    { "country-id": 826, "key": 5069, "label": "Redcar and Cleveland" },
    { "country-id": 826, "key": 5070, "label": "Richmond upon Thames" },
    { "country-id": 826, "key": 5071, "label": "Rochdale" },
    { "country-id": 826, "key": 5072, "label": "Rotherham" },
    { "country-id": 826, "key": 5073, "label": "Rutland" },
    { "country-id": 826, "key": 5074, "label": "Salford" },
    { "country-id": 826, "key": 5075, "label": "Shropshire" },
    { "country-id": 826, "key": 5076, "label": "Sandwell" },
    { "country-id": 826, "key": 5077, "label": "Sefton" },
    { "country-id": 826, "key": 5078, "label": "Sheffield" },
    { "country-id": 826, "key": 5079, "label": "Slough" },
    { "country-id": 826, "key": 5080, "label": "Solihull" },
    { "country-id": 826, "key": 5081, "label": "Somerset" },
    { "country-id": 826, "key": 5082, "label": "Southampton" },
    { "country-id": 826, "key": 5083, "label": "Southend-on-Sea" },
    { "country-id": 826, "key": 5084, "label": "South Gloucestershire" },
    { "country-id": 826, "key": 5085, "label": "South Tyneside" },
    { "country-id": 826, "key": 5086, "label": "Southwark" },
    { "country-id": 826, "key": 5087, "label": "Staffordshire" },
    { "country-id": 826, "key": 5088, "label": "St. Helens" },
    { "country-id": 826, "key": 5089, "label": "Stockport" },
    { "country-id": 826, "key": 5090, "label": "Stockton-on-Tees" },
    { "country-id": 826, "key": 5091, "label": "Stoke-on-Trent" },
    { "country-id": 826, "key": 5092, "label": "Suffolk" },
    { "country-id": 826, "key": 5093, "label": "Sunderland" },
    { "country-id": 826, "key": 5094, "label": "Surrey" },
    { "country-id": 826, "key": 5095, "label": "Sutton" },
    { "country-id": 826, "key": 5096, "label": "Swindon" },
    { "country-id": 826, "key": 5097, "label": "Tameside" },
    { "country-id": 826, "key": 5098, "label": "Telford and Wrekin" },
    { "country-id": 826, "key": 5099, "label": "Thurrock" },
    { "country-id": 826, "key": 5100, "label": "Torbay" },
    { "country-id": 826, "key": 5101, "label": "Tower Hamlets" },
    { "country-id": 826, "key": 5102, "label": "Trafford" },
    { "country-id": 826, "key": 5103, "label": "Wakefield" },
    { "country-id": 826, "key": 5104, "label": "Walsall" },
    { "country-id": 826, "key": 5105, "label": "Waltham Forest" },
    { "country-id": 826, "key": 5106, "label": "Wandsworth" },
    { "country-id": 826, "key": 5107, "label": "Warrington" },
    { "country-id": 826, "key": 5108, "label": "Warwickshire" },
    { "country-id": 826, "key": 5109, "label": "West Berkshire" },
    { "country-id": 826, "key": 5110, "label": "Westminster" },
    { "country-id": 826, "key": 5111, "label": "West Sussex" },
    { "country-id": 826, "key": 5112, "label": "Wigan" },
    { "country-id": 826, "key": 5113, "label": "Wiltshire" },
    { "country-id": 826, "key": 5114, "label": "Windsor and Maidenhead" },
    { "country-id": 826, "key": 5115, "label": "Wirral" },
    { "country-id": 826, "key": 5116, "label": "Wokingham" },
    { "country-id": 826, "key": 5117, "label": "Wolverhampton" },
    { "country-id": 826, "key": 5118, "label": "Worcestershire" },
    { "country-id": 826, "key": 5119, "label": "York" },
    { "country-id": 826, "key": 5120, "label": "Antrim" },
    { "country-id": 826, "key": 5121, "label": "Ards" },
    { "country-id": 826, "key": 5122, "label": "Armagh" },
    { "country-id": 826, "key": 5123, "label": "Ballymena" },
    { "country-id": 826, "key": 5124, "label": "Ballymoney" },
    { "country-id": 826, "key": 5125, "label": "Banbridge" },
    { "country-id": 826, "key": 5126, "label": "Belfast" },
    { "country-id": 826, "key": 5127, "label": "Carrickfergus" },
    { "country-id": 826, "key": 5128, "label": "Castlereagh" },
    { "country-id": 826, "key": 5129, "label": "Coleraine" },
    { "country-id": 826, "key": 5130, "label": "Cookstown" },
    { "country-id": 826, "key": 5131, "label": "Craigavon" },
    { "country-id": 826, "key": 5132, "label": "Down" },
    { "country-id": 826, "key": 5133, "label": "Dungannon" },
    { "country-id": 826, "key": 5134, "label": "Fermanagh" },
    { "country-id": 826, "key": 5135, "label": "Larne" },
    { "country-id": 826, "key": 5136, "label": "Limavady" },
    { "country-id": 826, "key": 5137, "label": "Lisburn" },
    { "country-id": 826, "key": 5138, "label": "Derry" },
    { "country-id": 826, "key": 5139, "label": "Magherafelt" },
    { "country-id": 826, "key": 5140, "label": "Moyle" },
    { "country-id": 826, "key": 5141, "label": "Newry and Mourne" },
    { "country-id": 826, "key": 5142, "label": "Newtownabbey" },
    { "country-id": 826, "key": 5143, "label": "North Down" },
    { "country-id": 826, "key": 5144, "label": "Omagh" },
    { "country-id": 826, "key": 5145, "label": "Strabane" },
    { "country-id": 826, "key": 5146, "label": "Aberdeen City" },
    { "country-id": 826, "key": 5147, "label": "Aberdeenshire" },
    { "country-id": 826, "key": 5148, "label": "Angus" },
    { "country-id": 826, "key": 5149, "label": "Argyll and Bute" },
    { "country-id": 826, "key": 5150, "label": "Scottish Borders, The" },
    { "country-id": 826, "key": 5151, "label": "Clackmannanshire" },
    { "country-id": 826, "key": 5152, "label": "Dumfries and Galloway" },
    { "country-id": 826, "key": 5153, "label": "Dundee City" },
    { "country-id": 826, "key": 5154, "label": "East Ayrshire" },
    { "country-id": 826, "key": 5155, "label": "East Dunbartonshire" },
    { "country-id": 826, "key": 5156, "label": "East Lothian" },
    { "country-id": 826, "key": 5157, "label": "East Renfrewshire" },
    { "country-id": 826, "key": 5158, "label": "Edinburgh, City of" },
    { "country-id": 826, "key": 5159, "label": "Falkirk" },
    { "country-id": 826, "key": 5160, "label": "Fife" },
    { "country-id": 826, "key": 5161, "label": "Glasgow City" },
    { "country-id": 826, "key": 5162, "label": "Highland" },
    { "country-id": 826, "key": 5163, "label": "Inverclyde" },
    { "country-id": 826, "key": 5164, "label": "Midlothian" },
    { "country-id": 826, "key": 5165, "label": "Moray" },
    { "country-id": 826, "key": 5166, "label": "North Ayrshire" },
    { "country-id": 826, "key": 5167, "label": "North Lanarkshire" },
    { "country-id": 826, "key": 5168, "label": "Orkney" },
    { "country-id": 826, "key": 5169, "label": "Perth and Kinross" },
    { "country-id": 826, "key": 5170, "label": "Renfrewshire" },
    { "country-id": 826, "key": 5171, "label": "Shetland Islands" },
    { "country-id": 826, "key": 5172, "label": "South Ayrshire" },
    { "country-id": 826, "key": 5173, "label": "South Lanarkshire" },
    { "country-id": 826, "key": 5174, "label": "Stirling" },
    { "country-id": 826, "key": 5175, "label": "West Dunbartonshire" },
    { "country-id": 826, "key": 5176, "label": "Eilean Siar" },
    { "country-id": 826, "key": 5177, "label": "West Lothian" },
    { "country-id": 826, "key": 5178, "label": "Isle of Anglesey" },
    { "country-id": 826, "key": 5179, "label": "Blaenau Gwent" },
    { "country-id": 826, "key": 5180, "label": "Bridgend" },
    { "country-id": 826, "key": 5181, "label": "Caerphilly" },
    { "country-id": 826, "key": 5182, "label": "Cardiff" },
    { "country-id": 826, "key": 5183, "label": "Ceredigion" },
    { "country-id": 826, "key": 5184, "label": "Carmarthenshire" },
    { "country-id": 826, "key": 5185, "label": "Conwy" },
    { "country-id": 826, "key": 5186, "label": "Denbighshire" },
    { "country-id": 826, "key": 5187, "label": "Flintshire" },
    { "country-id": 826, "key": 5188, "label": "Gwynedd" },
    { "country-id": 826, "key": 5189, "label": "Merthyr Tydfil" },
    { "country-id": 826, "key": 5190, "label": "Monmouthshire" },
    { "country-id": 826, "key": 5191, "label": "Neath Port Talbot" },
    { "country-id": 826, "key": 5192, "label": "Newport" },
    { "country-id": 826, "key": 5193, "label": "Pembrokeshire" },
    { "country-id": 826, "key": 5194, "label": "Powys" },
    { "country-id": 826, "key": 5195, "label": "Rhondda, Cynon, Taff" },
    { "country-id": 826, "key": 5196, "label": "Swansea" },
    { "country-id": 826, "key": 5197, "label": "Torfaen" },
    { "country-id": 826, "key": 5198, "label": "Vale of Glamorgan, The" },
    { "country-id": 826, "key": 5199, "label": "Wrexham" },
    { "country-id": 528, "key": 6555, "label": "Drenthe" },
    { "country-id": 528, "key": 6556, "label": "Friesland" },
    { "country-id": 528, "key": 6557, "label": "Gelderland" },
    { "country-id": 528, "key": 6558, "label": "Groningen" },
    { "country-id": 528, "key": 6559, "label": "Limburg" },
    { "country-id": 528, "key": 6560, "label": "Noord-Brabant" },
    { "country-id": 528, "key": 6561, "label": "Noord-Holland" },
    { "country-id": 528, "key": 6562, "label": "Utrecht" },
    { "country-id": 528, "key": 6563, "label": "Zeeland" },
    { "country-id": 528, "key": 6564, "label": "Zuid-Holland" },
    { "country-id": 528, "key": 6565, "label": "Overijssel" },
    { "country-id": 528, "key": 6566, "label": "Flevoland" },
    { "country-id": 554, "key": 6614, "label": "Chatham Islands" },
    { "country-id": 554, "key": 6615, "label": "Auckland" },
    { "country-id": 554, "key": 6616, "label": "Bay of Plenty" },
    { "country-id": 554, "key": 6617, "label": "Canterbury" },
    { "country-id": 554, "key": 6618, "label": "Gisborne" },
    { "country-id": 554, "key": 6619, "label": "Hawkes's Bay" },
    { "country-id": 554, "key": 6620, "label": "Manawatu-Wanganui" },
    { "country-id": 554, "key": 6621, "label": "Marlborough" },
    { "country-id": 554, "key": 6622, "label": "Nelson" },
    { "country-id": 554, "key": 6623, "label": "Northland" },
    { "country-id": 554, "key": 6624, "label": "Otago" },
    { "country-id": 554, "key": 6625, "label": "Southland" },
    { "country-id": 554, "key": 6626, "label": "Taranaki" },
    { "country-id": 554, "key": 6627, "label": "Waikato" },
    { "country-id": 554, "key": 6628, "label": "Wellington" },
    { "country-id": 554, "key": 6629, "label": "West Coast" },
    { "country-id": 752, "key": 7105, "label": "Blekinge Lan" },
    { "country-id": 752, "key": 7106, "label": "Gävleborgs län [SE-21]" },
    { "country-id": 752, "key": 7107, "label": "Gotlands Lan" },
    { "country-id": 752, "key": 7108, "label": "Hallands län [SE-13]" },
    { "country-id": 752, "key": 7109, "label": "Jämtlands län  [SE-23]" },
    { "country-id": 752, "key": 7110, "label": "Jonkopings Lan" },
    { "country-id": 752, "key": 7111, "label": "Kalmar Lan" },
    { "country-id": 752, "key": 7112, "label": "Dalarnas län [SE-20]" },
    { "country-id": 752, "key": 7113, "label": "Kronobergs län [SE-07]" },
    { "country-id": 752, "key": 7114, "label": "Norrbottens län  [SE-25]" },
    { "country-id": 752, "key": 7115, "label": "Orebro Lan" },
    { "country-id": 752, "key": 7116, "label": "Östergötlands län [SE-05]" },
    { "country-id": 752, "key": 7117, "label": "Sodermanlands Lan" },
    { "country-id": 752, "key": 7118, "label": "Uppsala län [SE-03]" },
    { "country-id": 752, "key": 7119, "label": "Värmlands län  [SE-17]" },
    { "country-id": 752, "key": 7120, "label": "Västerbottens län[SE-24]" },
    { "country-id": 752, "key": 7121, "label": "Västernorrlands län [SE-22]" },
    { "country-id": 752, "key": 7122, "label": "Vastmanlands Lan" },
    { "country-id": 752, "key": 7123, "label": "Stockholms län [SE-01]" },
    { "country-id": 752, "key": 7124, "label": "Skåne län [SE-12]" },
    { "country-id": 752, "key": 7125, "label": "Västra Götalands län [SE-14]" }];


export {
    config,
    isCouponValid,
    doesCouponCodeExist,
    countries,
    territories
};



// WEBPACK FOOTER //
// ./src/components/Signup-dat.js